import styled from 'styled-components';
import {
  colors,
  borderRadius,
  transitions,
  transforms,
  mixins,
  spacing,
  opacity,
} from '../../design-system';
import { tokens } from 'design-tokens/warwick/tokens';

// TV-Optimized: Simple transforms, no heavy effects
export const Container = styled.div`
  ${mixins.serviceCardContainer}
  transform: scale(${(props) => (props.active ? tokens.semantic.size.menuItem.scaleActive : 1)});
  box-shadow: ${tokens.primitive.shadow.sm};
`;

export const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  img {
    ${mixins.serviceCardImage}
  }
`;

// TV-Optimized: Simple overlay, no blur
export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${(props) =>
    props.active
      ? tokens.semantic.gradient.mainSelectedCard
      : tokens.semantic.gradient.mainUnselectedCard};
`;

export const ContentWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: ${tokens.primitive.space[37]} ${tokens.primitive.space[41]};
  z-index: 2;
`;

export const Title = styled.h3`
  ${(props) => mixins.textServiceTitle(props)}
  margin: 0 0 ${tokens.primitive.space[11]} 0;
`;

export const Description = styled.p`
  ${(props) => mixins.textServiceDescription(props)}
  margin: 0;
`;
